import Vue from 'vue'
import './plugins/vuetify'
import './plugins/vueDraggable'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import auth from './services/authService'
import moment from 'moment';
import * as Constants from "@/helpers/constants";
import ValidationRules from "@/helpers/validationrules";

Vue.config.productionTip = false;
if(process.env.VUE_APP_REDIRECT_URI.includes('localhost')){
  Vue.config.devtools = true
}
moment.locale('en-au');

// make this available in every component - https://forum.vuejs.org/t/single-file-component-how-to-access-imported-library-in-template/8850
// this prevents us from having to make computed properties in individual components for commonly used imports, like this:
/**
 * private get constants() {
 *     return constants;
 * }
 */
// instead we can just use this.$constants.WHATEVER in the script, or {{ $constants.WHATEVER }} in the template
Vue.prototype.$Constants = Constants;
Vue.prototype.$ValidationRules = ValidationRules;
Vue.prototype.$moment = moment;

Vue.filter('formatNumberTo2Decimals', function (value) {
  if (value) {
    return value.toFixed(2)
  }
  else {
    let l_zero = 0;
    return l_zero.toFixed(2)
  }
})

Vue.filter('formatNumberTo0Decimals', function (value) {
  if (value) {
    return value.toFixed(0)
  }
  else {
    let l_zero = 0;
    return l_zero.toFixed(0)
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment.parseZone(value).format("DD/MM/YYYY hh:mm A")
  }
  else {
    return "";
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(value).format("DD/MM/YYYY")
  }
  else {
    return "";
  }
})

Vue.filter('formatDateYMD', function (value) {
  if (value) {
    return moment(value).format("YYYY-MM-DD")
  }
  else {
    return "";
  }
})

Vue.filter('formatDecimalToPercentage', function (value) {
  if (value) {
    return (value * 100).toFixed(2) + '%'
  }
  else {
    let l_zero = 0;
    return l_zero.toFixed(2) + '%'
  }
})

Vue.filter('formatDecimalToPercentageInt', function (value) {
  if (value) {
    return (value * 100).toFixed(0) + '%'
  }
  else {
    let l_zero = 0;
    return l_zero.toFixed(0) + '%'
  }
})

Vue.filter('thousandsSeparators',  function(num)
{   
    if(num == null) return "";
    
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
})

// Init adal authentication - then create Vue app.
auth.initialize().then(() => {
  initVue();
}, () => {
  initVue();
});

function initVue(){
  new Vue({
      router,
      store,
      render: h => h(App)
  }).$mount('#app')
}
